import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import {
  STAGING_LINK,
  PROD_LINK,
  API_URL,
  getAssetImage,
} from "../../constant";
import { IS_STAGING } from "../../constant/api";
import { IoArrowUp } from "react-icons/io5";
import { MdAdd } from "react-icons/md";
import WalletGraph from "./WalletGraph";
// import { BiExport } from "react-icons/bi";
import { useAuth } from "../../context/auth-context";
import axiosInstance from "../../utils/axiosConfig";
import Receive from "./crypto/Receive";
import Withdraw from "./crypto/Withdraw";
// import Wallets from "./Wallets";
import DepositFiat from "./fiat/DepositFiat";
import WithdrawFiat from "./fiat/WithdrawFiat";
import { TailSpin } from "react-loader-spinner";
import ConfirmWithdrawal from "./fiat/ConfirmWithdrawal";
import SuccessFiat from "./fiat/SuccessFiat";
import WalletActivities from "./WalletActivities";
import { BiExport } from "react-icons/bi";
import { fetchWalletActivitiesForExport } from "./fetchWalletActivitiesExport";
import { buildWalletActivitiesCsv } from "./walletActivitiesTable";
import { fetchPayrollActivitiesForExport } from "./fetchPayrollActivitiesExport";
import { buildPayrollActivitiesCsv } from "./payrollActivitiesTable";
import RangeExportModal from "../../components/admin-export/RangeExportModal";
import type { IsoDateRange } from "../../lib/adminExport/datePresets";
import { FaArrowCircleRight, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import CreatePayroll from "./payroll/CreatePayroll";
import ConfirmCreatePayroll from "./payroll/ConfirmCreatePayroll";
import PayrollSuccess from "./payroll/PayrollSuccess";
import PayrollActivities from "./PayrollActivities";
import { formatAmount } from "../../utils/FormatPerson";
import DepositPalmFiat from "./fiat/DepositPalmFiat";

const Wallet = () => {
  const {
    withdrawModal,
    setWithdrawModal,
    isAuthenticated,
    isOpened,
    isNotified,
    logout,
  } = useAuth();
  const [receiveModal, setReceiveModal] = useState<boolean>(false);
  const [btcValue, setBtcValue] = useState<number | any>();
  const [usdtValue, setUsdtValue] = useState<number | null>(null);
  const [nairaBalance, setNairaBalance] = useState<number | any>();
  const [depositFiatModal, setDepositFiatModal] = useState<boolean>(false);
  const [withdrawFiatModal, setWithdrawFiatModal] = useState<boolean>(false);
  const [autoWithdraw, setAutoWithdraw] = useState<string>("");
  const [payLoader, setPayLoader] = useState<boolean>(false);
  const [refetchCounter, setRefetchCounter] = useState<number>(0);
  const [confirmFiatModal, setConfirmFiatModal] = useState<boolean>(false);
  const [successFiatModal, setSuccessFiatModal] = useState<boolean>(false);
  const [bankCode, setBankCode] = useState<string>("");
  const [active, setActive] = useState<boolean>(true);
  const [bankNumber, setBankNumber] = useState<string>("");
  const [visibleB, setVisibleB] = useState<boolean>(false);
  const [exportOpen, setExportOpen] = useState<boolean>(false);
  const [withdrawAmount, setWithdrawAmount] = useState<number | string>("");
  const [transacion, setTransaction] = useState<boolean>(false);
  const [openPayroll, setOpenPayroll] = useState<boolean>(false);
  const [openPayrollConfirm, setOpenPayrollConfirm] = useState<boolean>(false);
  const [openPayrollSuccess, setOpenPayrollSuccess] = useState<boolean>(false);
  const [selectedStaffs, setSelectedStaffs] = useState<string[]>([]); // Array of selected staff IDs
  const [walletType, setWalletType] = useState<string>("deex");
  const [summaryLoader, setSummaryLoader] = useState<boolean>(false);
  const [summary, setSummary] = useState<any>({});
  const [depositPalmModal, setDepositPalmModal] = useState<boolean>(false);

  useEffect(() => {
    setPayLoader(true);
    setTimeout(() => {
      axiosInstance
        .get(`${API_URL}api/settings`)
        .then((r: any) => {
          setAutoWithdraw(r.data.data.autoWithdrawalStatus);

          setPayLoader(false);
        })
        .catch((e: any) => {
          setPayLoader(false);
          console.log(e.response.data.message);
        });
    }, 1500);
  }, [isAuthenticated, refetchCounter]);

  useEffect(() => {
    axiosInstance
      .get(`${API_URL}api/wallets/admin?currency=all`)
      .then((r: any) => {
        const newNairaBalance = r.data.data.hizo.balance;
        // console.log(r.data);
        setNairaBalance(newNairaBalance);
        const walletBalance = r.data.data.quidax;
        const btcObject = walletBalance.find(
          (obj: any) => obj.name === "Bitcoin"
        );
        const usdtObject = walletBalance.find(
          (obj: any) => obj.name === "USDT Tether"
        );
        if (btcObject) {
          setBtcValue(btcObject.balance);
        }
        if (usdtObject) {
          const balance = parseFloat(usdtObject.balance);
          setUsdtValue(!isNaN(balance) ? balance : null);
        }
      })
      .catch((e: any) => {
        console.log(e.response.data.message);
        if (
          e.response.status === 401 &&
          e.response.data.message === "Inavlid token. Please login again!"
        ) {
          logout();
        }
      });
  }, [isAuthenticated, logout]);

  const handleChange = () => {
    if (autoWithdraw === "inactive") {
      if (!payLoader) {
        setPayLoader(true);
        axiosInstance
          .patch(`${API_URL}api/settings/autowithdrawal-status`, {
            status: "active",
          })
          .then((r: any) => {
            // console.log(r.data);
            setRefetchCounter((prev) => prev + 1);
            setPayLoader(false);
            // .location.reload();
          })
          .catch((e: any) => {
            console.log(e.response.data.message);
          });
      }
    } else {
      if (!payLoader) {
        setPayLoader(true);
        axiosInstance
          .patch(`${API_URL}api/settings/autowithdrawal-status`, {
            status: "inactive",
          })
          .then((r: any) => {
            setRefetchCounter((prev) => prev + 1);
            setPayLoader(false);
            // window.location.reload();
          })
          .catch((e: any) => {
            console.log(e.response.data.message);
          });
      }
    }
  };

  useEffect(() => {
    if (!summaryLoader) {
      setTimeout(() => {
        setSummaryLoader(true);
        axiosInstance
          .get(`${API_URL}api/wallets/admin/balance`)
          .then((r: any) => {
            setSummary(r?.data?.data);
            setSummaryLoader(false);
          })
          .catch((e: any) => {
            console.log(e.response.data.message);
            setSummaryLoader(false);
          });
      }, 3000);
    }
  }, [isAuthenticated]);
  // console.log(summary);

  const exportConfig = useMemo(
    () =>
      transacion
        ? {
            title: "Payroll activities",
            fileBasename: "payroll-activities",
            fetchRows: (range: IsoDateRange | null) =>
              fetchPayrollActivitiesForExport(range),
            buildCsv: buildPayrollActivitiesCsv,
          }
        : {
            title: "Wallet activities",
            fileBasename: "wallet-activities",
            fetchRows: (range: IsoDateRange | null) =>
              fetchWalletActivitiesForExport(range),
            buildCsv: buildWalletActivitiesCsv,
          },
    [transacion]
  );

  // console.log(summary);

  return (
    <div className="w-full h-screen flex flex-col overflow-hidden">
      <div className="w-full h-[31px] shrink-0 bg-[#1B1B1B] flex justify-center items-center">
        {IS_STAGING ? (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in Staging:{" "}
            <span>
              <a href={PROD_LINK} className="text-[#03C668]">
                Switch to Prod
              </a>
            </span>
          </h4>
        ) : (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in PROD:{" "}
            <span>
              <a href={STAGING_LINK} className="text-[#DF4E4E]">
                Switch to Staging
              </a>
            </span>
          </h4>
        )}
      </div>
      <div className="flex flex-1 min-h-0 w-full flex-col lgss:flex-row overflow-hidden">
        <Sidebar />
        <div className="w-full lgss:w-10/12 flex-1 min-h-0 min-w-0 overflow-y-auto bg-[#13181B]">
          <Navbar />

          <div className="w-full px-5 pt-8 mds:px-12 font-manrope lgss:px-10 pb-24 bg-[#13181B]">
            <div className="w-full flex justify-between gap-2 items-center ">
              <h4 className="text-white font-sora font-semibold text-[10px]">
                WALLETS
              </h4>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setVisibleB((prev) => !prev)}
                  className="flex items-center uppercase mt-1 gap-2 font-sora text-[#869AA9] font-semibold text-[10px]"
                >
                  {visibleB ? (
                    <FaRegEye className="w-[14px] h-[14px] text-[#4E606E]" />
                  ) : (
                    <FaRegEyeSlash className="w-[14px] h-[14px] text-[#4E606E]" />
                  )}
                  {visibleB ? "HIDE" : "SHOW"} Balance
                </button>
                <h4 className="mt-1 text-[#3A4852]">|</h4>
                <button
                  type="button"
                  onClick={() => setExportOpen(true)}
                  className="flex gap-1 items-center"
                >
                  <BiExport className="text-[white]" />
                  <h4 className="uppercase font-sora font-semibold mt-1 text-[#869AA9] text-[10px]">
                    Export
                  </h4>
                </button>
              </div>
            </div>
            <div className="w-full flex justify-start items-center border-b mt-3 border-gray-800">
              <button
                onClick={() => setWalletType("deex")}
                className={`${
                  walletType === "deex"
                    ? "border-secondary_button text-secondary_button border-b-2  text-[15px] font-bold"
                    : " text-gray-200 text-[14px]"
                } px-4 py-2 `}
              >
                DeeX Wallet
              </button>
              <button
                onClick={() => setWalletType("customers")}
                className={`${
                  walletType === "customers"
                    ? "border-secondary_button text-secondary_button border-b-2  text-[15px] font-bold"
                    : " text-gray-200 text-[14px]"
                } px-4  py-2 `}
              >
                Customers Wallet
              </button>
            </div>

            <div className="w-full flex justify-start items-center   mt-4  gap-4">
              <div className="w-full lgss:w-1/3 bg-[#1C2227] rounded-sm  p-5">
                <h4 className="text-[#E7EBEE]  font-bold text-[11px]">
                  Total Crypto
                </h4>
                <h4 className="font-sora font-bold text-[24px] text-[#BEE1FB] mt-2">
                  {visibleB
                    ? `$${
                        walletType === "deex"
                          ? summary?.obiex?.totalObiexHoldingsInUSD
                            ? formatAmount(
                                summary?.obiex?.totalObiexHoldingsInUSD
                              )
                            : "0.00"
                          : summary?.users?.totalUserHoldingsInUSD
                          ? formatAmount(summary?.users?.totalUserHoldingsInUSD)
                          : "0.00"
                      }`
                    : `********`}
                </h4>
                {walletType === "deex" && (
                  <div className="w-full mt-6 gap-2 flex justify-start items-center">
                    <button
                      onClick={() => setReceiveModal((prev) => !prev)}
                      className="w-1/2 md:w-[45%] gap-2 flex justify-center items-center py-3 text-white bg-secondary_button font-bold text-[15px] rounded-lg"
                    >
                      <div className="w-[24px] h-[24px] flex justify-center items-center text-[16px] text-white bg-[#095B97] rounded-lg">
                        <MdAdd />
                      </div>
                      <h4>Fund Wallet</h4>
                    </button>
                    <button
                      onClick={() => setWithdrawModal((prev: any) => !prev)}
                      className="w-1/2 md:w-[45%] gap-2 flex justify-center items-center py-3 px-3 text-[#1C2227] bg-[#F7F8F9] font-bold text-[15px] rounded-lg"
                    >
                      <div className="w-[24px] h-[24px] flex justify-center items-center text-[16px] text-[#1C2227] bg-[#E7EBEE] rounded-lg">
                        <IoArrowUp />
                      </div>
                      <h4>Withdraw</h4>
                    </button>
                  </div>
                )}
              </div>
              {walletType === "deex" && (
                <div className="w-full lgss:w-2/3 gap-4 flex justify-center items-center">
                  <div className="w-full lgss:w-1/2 bg-[#1C2227] rounded-sm  p-5">
                    <h4 className="text-[#E7EBEE]  font-bold text-[11px]">
                      Glyde Balance
                    </h4>
                    <h4 className="font-sora font-bold text-[24px] text-[#BEE1FB] mt-2">
                      {visibleB
                        ? `₦${
                            summary?.glydeBalance?.balance
                              ? formatAmount(summary?.glydeBalance?.balance)
                              : 0.0
                          }`
                        : `********`}
                    </h4>
                    <div className="w-full  mt-6 gap-2 flex justify-start items-center">
                      <button
                        onClick={() => setDepositFiatModal((prev) => !prev)}
                        className="w-1/2 md:w-[45%] gap-2 flex justify-center items-center py-3 text-white bg-secondary_button font-bold text-[15px] rounded-lg"
                      >
                        <div className="w-[24px] h-[24px] flex justify-center items-center text-[16px] text-white bg-[#095B97] rounded-lg">
                          <MdAdd />
                        </div>
                        <h4>Fund Wallet</h4>
                      </button>
                      {/* <button
                        onClick={() =>
                          setWithdrawFiatModal((prev: any) => !prev)
                        }
                        className="w-1/2 md:w-[45%] gap-2 flex justify-center items-center py-3 px-3 text-[#1C2227] bg-[#F7F8F9] font-bold text-[15px] rounded-lg"
                      >
                        <div className="w-[24px] h-[24px] flex justify-center items-center text-[16px] text-[#1C2227] bg-[#E7EBEE] rounded-lg">
                          <IoArrowUp />
                        </div>
                        <h4>Withdraw</h4>
                      </button> */}
                    </div>
                  </div>
                  <div className="w-full lgss:w-1/2 bg-[#1C2227] rounded-sm  p-5">
                    <h4 className="text-[#E7EBEE]  font-bold text-[11px]">
                      Palmpay Balance
                    </h4>
                    <h4 className="font-sora font-bold text-[24px] text-[#BEE1FB] mt-2">
                      {visibleB
                        ? `₦${
                            summary?.palmpayBalance
                              ? formatAmount(summary?.palmpayBalance)
                              : 0.0
                          }`
                        : `********`}
                    </h4>
                    <div className="w-full  mt-6 gap-2 flex justify-start items-center">
                      <button
                        onClick={() => setDepositPalmModal((prev) => !prev)}
                        className="w-1/2 md:w-[45%] gap-2 flex justify-center items-center py-3 text-white bg-secondary_button font-bold text-[15px] rounded-lg"
                      >
                        <div className="w-[24px] h-[24px] flex justify-center items-center text-[16px] text-white bg-[#095B97] rounded-lg">
                          <MdAdd />
                        </div>
                        <h4>Fund Wallet</h4>
                      </button>
                      {/* <button
                        onClick={() =>
                          setWithdrawFiatModal((prev: any) => !prev)
                        }
                        className="w-1/2 md:w-[45%] gap-2 flex justify-center items-center py-3 px-3 text-[#1C2227] bg-[#F7F8F9] font-bold text-[15px] rounded-lg"
                      >
                        <div className="w-[24px] h-[24px] flex justify-center items-center text-[16px] text-[#1C2227] bg-[#E7EBEE] rounded-lg">
                          <IoArrowUp />
                        </div>
                        <h4>Withdraw</h4>
                      </button> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="w-full overflow-x-auto mt-10 pb-4">
              <div className="flex gap-4 w-max">
                {Object.entries(
                  walletType === "customers"
                    ? summary?.users?.detailedBalance ?? {}
                    : summary?.obiex?.detailedObiexBalance ?? {}
                ).map(([key, value]) => {
                  const coinKey = key.toString();
                  const coinImage = getAssetImage(coinKey);
                  const coinData = value as {
                    amount: number;
                    usdValue: number;
                  };

                  return (
                    <div
                      key={coinKey}
                      className="w-full mds:w-1/2 md:w-1/3 xxl:w-1/4 min-w-[280px] rounded-xl bg-[#1C2227] p-6"
                    >
                      <div className="flex justify-start gap-2 items-center">
                        <div className="w-[24px] h-[24px] rounded-full flex justify-center items-center">
                          {coinImage ? (
                            <img
                              src={coinImage}
                              className="w-full h-full object-contain"
                              alt={coinKey.toUpperCase()}
                            />
                          ) : (
                            <span className="text-[9px] font-bold text-[#869AA9]">
                              {coinKey.toUpperCase().slice(0, 3)}
                            </span>
                          )}
                        </div>
                        <h4 className="text-[12px] text-white font-bold">
                          {coinKey.toUpperCase()}
                        </h4>
                      </div>
                      <h4 className="font-sora text-[#BEE1FB] font-bold text-[20px] mt-3">
                        {visibleB
                          ? `${formatAmount(
                              coinData?.amount
                            )} ${coinKey.toUpperCase()}`
                          : `********`}
                      </h4>
                      <div className="px-4 py-2 inline-block rounded-lg bg-[#273037] text-white mt-3 text-[11.8px]">
                        {visibleB
                          ? `$ ${formatAmount(coinData?.usdValue)}`
                          : `********`}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="w-full flex mt-6 justify-between gap-2 items-center ">
              <h4 className="text-white font-sora font-semibold text-[10px]">
                PERFORMANCE
              </h4>
            </div>
            <div className="w-full flex flex-col gap-4 justify-center items-center">
              <div className="w-full">
                <div className="mt-4 bg-[#1C2227] p-5">
                  <h4 className="text-[#E7EBEE]  font-bold text-[11px]">
                    Trade Volume
                  </h4>
                  <div
                    className={
                      receiveModal || withdrawModal
                        ? "w-full h-[500px]"
                        : "w-full "
                    }
                  >
                    {!receiveModal &&
                    !withdrawModal &&
                    !isOpened &&
                    !openPayroll &&
                    !openPayrollConfirm &&
                    !openPayrollSuccess &&
                    !isNotified ? (
                      <WalletGraph />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full flex justify-between items-center mt-28 mb-6">
              <h4 className="text-white font-sora font-semibold text-[12px]">
                Activity
              </h4>
              <div className="flex gap-4 items-center">
                <div className="flex items-center gap-2">
                  <div
                    onClick={() => setActive(true)}
                    className={`flex w-6  cursor-pointer h-3   rounded-full transition-all duration-500 ${
                      active ? "bg-secondary_button" : "bg-gray-600"
                    }`}
                  >
                    <span
                      className={`h-3 w-3   rounded-full transition-all duration-500 bg-gray-100 ${
                        active ? "ml-3" : ""
                      }`}
                    ></span>
                  </div>
                  <h4 className="uppercase font-sora font-semibold text-[#869AA9] text-[10px]">
                    Auto swap :{" "}
                    <span
                      className={active ? "text-[#359943]" : "text-[#617889]"}
                    >
                      {active ? "on" : "off"}
                    </span>
                  </h4>
                </div>
                <h4 className="text-[#3A4852]">|</h4>
                <div className="flex items-center gap-2">
                  {payLoader ? (
                    <TailSpin color="#0B75C2" height={20} width={20} />
                  ) : (
                    <div
                      onClick={handleChange}
                      className={`flex w-8  cursor-pointer h-4   rounded-full transition-all duration-500 ${
                        autoWithdraw === "active"
                          ? "bg-secondary_button"
                          : "bg-gray-600"
                      }`}
                    >
                      <span
                        className={`h-4 w-4   rounded-full transition-all duration-500 bg-gray-100 ${
                          autoWithdraw === "active" ? "ml-4" : ""
                        }`}
                      ></span>
                    </div>
                  )}
                  <h4 className="uppercase font-sora font-semibold text-[#869AA9] text-[10px]">
                    Auto Withdrawal:{" "}
                    <span
                      className={
                        autoWithdraw === "active" ? "text-[#359943]" : ""
                      }
                    >
                      {autoWithdraw === "active" ? " ON" : " OFF"}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
            <div className="bg-[#0D0D0D] w-full flex justify-between items-center pr-12 h-[67px] mt-4">
              <div className="w-1/2 h-full flex justify-start items-center">
                <button
                  onClick={() => {
                    setTransaction(false);
                  }}
                  className={
                    !transacion
                      ? "border-secondary_button h-full px-6 text-[16px] font-semibold text-secondary_button border-b-2 "
                      : " h-full px-6 text-[14px]  text-[#C6D0D7]  "
                  }
                >
                  All
                </button>
                <button
                  onClick={() => setTransaction(true)}
                  className={
                    transacion
                      ? "border-secondary_button h-full px-6 text-[16px] font-semibold text-secondary_button border-b-2 "
                      : " h-full px-6 text-[14px]  text-[#C6D0D7]  "
                  }
                >
                  Payroll
                </button>
              </div>

              <button
                onClick={() => setOpenPayroll(true)}
                className="px-4 py-2 rounded-xl gap-2 bg-secondary_button text-white text-[15px] justify-center items-center flex"
              >
                <h4>Create Payroll</h4>
                <FaArrowCircleRight className="text-[11px]" />
              </button>
            </div>
            {transacion ? <PayrollActivities /> : <WalletActivities />}
          </div>
        </div>
      </div>
      {withdrawModal ? (
        <Withdraw btcValue={btcValue} usdtValue={usdtValue} />
      ) : null}
      {receiveModal && <Receive setRecieveModal={setReceiveModal} />}
      {depositFiatModal && (
        <DepositFiat setDepositFiatModal={setDepositFiatModal} />
      )}
      {depositPalmModal && (
        <DepositPalmFiat setDepositPalmModal={setDepositPalmModal} />
      )}
      {withdrawFiatModal && (
        <WithdrawFiat
          setWithdrawFiatModal={setWithdrawFiatModal}
          setConfirmFiatModal={setConfirmFiatModal}
          withdrawAmount={withdrawAmount}
          setWithdrawAmount={setWithdrawAmount}
          bankCode={bankCode}
          setBankCode={setBankCode}
          bankNumber={bankNumber}
          setBankNumber={setBankNumber}
        />
      )}
      {confirmFiatModal && (
        <ConfirmWithdrawal
          setConfirmFiatModal={setConfirmFiatModal}
          withdrawAmount={withdrawAmount}
          bankCode={bankCode}
          bankNumber={bankNumber}
          setSuccessFiatModal={setSuccessFiatModal}
        />
      )}
      {successFiatModal && (
        <SuccessFiat setSuccessFiatModal={setSuccessFiatModal} />
      )}
      {openPayroll && (
        <CreatePayroll
          setOpenPayroll={setOpenPayroll}
          setOpenPayrollConfirm={setOpenPayrollConfirm}
          setSelectedStaffs={setSelectedStaffs}
          selectedStaffs={selectedStaffs}
        />
      )}
      {openPayrollConfirm && (
        <ConfirmCreatePayroll
          setOpenPayroll={setOpenPayroll}
          setOpenPayrollConfirm={setOpenPayrollConfirm}
          setOpenPayrollSuccess={setOpenPayrollSuccess}
          selectedStaffs={selectedStaffs}
        />
      )}
      {openPayrollSuccess && (
        <PayrollSuccess setOpenPayrollSuccess={setOpenPayrollSuccess} />
      )}
      <RangeExportModal
        open={exportOpen}
        onClose={() => setExportOpen(false)}
        title={exportConfig.title}
        fileBasename={exportConfig.fileBasename}
        fetchRows={exportConfig.fetchRows}
        buildCsv={exportConfig.buildCsv}
      />
    </div>
  );
};

export default Wallet;
